import React from "react";
import { Link } from "react-router-dom";

import discover1 from "../../../assets/img/blog/WA0045.jpg";
import discover2 from "../../../assets/img/blog/WA0046.jpg";
import discover3 from "../../../assets/img/blog/WA0047.jpg";

import { useTranslation } from "react-i18next";
const popularPosts = [
  {
    title: "Transform Your Outdoor Space: Expert Landscaping Tips & Ideas",
    postBy: "Vinca Horticulture & Landscaping",
    img_url: discover1,
    postDate: "December 23, 2024",
  },
  {
    title: "Landscaping Inspiration for Every Season",
    postBy: "Vinca Horticulture & Landscaping",
    img_url: discover2,
    postDate: "February 6, 2025",
  },
  {
    title: " Simple Landscaping Upgrades That Wow",
    postBy: "Vinca Horticulture & Landscaping",
    img_url: discover3,
    postDate: "December 6, 2024",
  },
];

const DiscoverKeras = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="discoverKerasSec bgGray sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="fisherman-content">
                <h6>{t("Post From Blogs")}</h6>
                <h3>{t("Our Latest News Update")}</h3>
              </div>
            </div>
            {popularPosts.map((item, i) => {
              return (
                <div className="col-lg-4 col-md-4 col-sm-6 " key={i}>
                  <div className="discoverCard">
                    <div className="figure">
                      <img
                        src={item.img_url}
                        alt={item.title}
                        className="img-fluid"
                        title={item.title}
                      />
                    </div>
                    <div className="text">
                      <h6>{t(`${item.postBy}`)}</h6>
                      <h4>{t(`${item.title}`)}</h4>
                      <p className="mb-1">
                        Post By: {t(`${item.postBy}`)}
                      </p>
                      <p>Date:  {t(`${item.postDate}`)}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default DiscoverKeras;
